import React, {
  forwardRef,
  useEffect,
  useImperativeHandle,
  useRef,
  useState,
} from "react";
import { useFormik } from "formik";
import toast from "react-hot-toast";

import "./createCatalogoItem.css";

import {
  createCatalogoItemFormShortValidate,
  createCatalogoItemFormValidate,
} from "../../../../helper/validate";
import * as api from "helper/helper";
import invalidClass, { formikExtra } from "../../helperFunctions/helpers";
import LoadingButton from "../LoadingButton/LoadingButton";
import { CatalogosIds } from "./ProductosCaracteristicas";

const CreateCatalogoItem = forwardRef(
  ({ item, reloadItems, catalogoItem }, ref) => {
    const modalRef = useRef();
    const buttonCancelModalRef = useRef();

    const [isActiveDisabled, setIsActiveDisabled] = useState(true);
    const [isLoading, setIsLoading] = useState(false);

    const createMode = item == null || (item && Object.keys(item).length === 0);
    const type = catalogoItem?.nombreSingle ?? "";
    const title = `${createMode ? "Crear" : "Editar"} ${type}`;

    useEffect(() => {
      console.log("---> change item: " + item);
      let isActiveDisable = true;
      if (!createMode) {
        isActiveDisable = false;
      }
      setIsActiveDisabled(isActiveDisable);

      formik?.resetForm();
    }, [item]);

    useEffect(() => {
      formik?.resetForm();
    }, []);

    let initialValues = {
      id: 0,
      activo: true,
      num: "",
      nombreCorto: "",
      nombre: "",
    };

    if (!createMode) {
      initialValues = { ...item };
    }

    const formik = useFormik({
      initialValues,
      enableReinitialize: true,
      validate: validateInput,
      validateOnBlur: false,
      validateOnChange: false,
      onSubmit: async (values) => {
        if (values.id === 0) {
          const toastId = toast.loading(`Creando ${type}...`);
          setIsLoading(true);

          let createApiCall = createCall(values);
          let response = await createApiCall.catch((e) => {
            setIsLoading(false);
            toast.dismiss(toastId);
            if (e.esError && e.codigoError && e.mensaje) {
              toast.error(`Error al crear ${type}, ${e.mensaje}`);
              return;
            }
            toast.error(`Error al crear ${type}.`);
          });

          setIsLoading(false);
          toast.dismiss(toastId);

          if (!response) return;

          toast.success(`${type} creado.`);
          reloadItems();

          buttonCancelModalRef.current.click();
        } else {
          let updateActivoApiCall = updateActivoCall();
          let updateCall = updateActivoApiCall[0];
          let activoCall = updateActivoApiCall[1];

          const toastId = toast.loading(`Actualizando ${type}...`);
          setIsLoading(true);
          const response = await updateCall(values.id, values).catch((e) => {
            setIsLoading(false);
            toast.dismiss(toastId);
            if (e.esError && e.codigoError && e.mensaje) {
              toast.error(`Error al actualizar ${type}, ${e.mensaje}`);
              return;
            }
            toast.error(`Error al actualizar ${type}.`);
          });
          if (!response) return;

          const responseActivo = await activoCall(
            values.id,
            values.activo,
          ).catch((e) => {
            setIsLoading(false);
            toast.dismiss(toastId);
            if (e.esError && e.codigoError && e.mensaje) {
              toast.error(`Error al actualizar activo ${type}, ${e.mensaje}`);
              return;
            }
            toast.error(`Error al actualizar activo ${type}.`);
          });

          toast.dismiss(toastId);
          setIsLoading(false);

          if (!responseActivo) return;

          toast.success(`${type} actualizado.`);
          reloadItems();

          buttonCancelModalRef.current.click();
        }
      },
    });

    useImperativeHandle(ref, () => ({
      getValue: () => {
        return formik.values;
      },
      toggleModal: () => {
        formik?.resetForm();
        modalRef.current.click();
      },
    }));

    function createCall(values) {
      let createCall = null;
      if (catalogoItem.id === CatalogosIds.Marcas) {
        createCall = api.createMarca(values);
      } else if (catalogoItem.id === CatalogosIds.Generos) {
        createCall = api.createGenero(values);
      } else if (catalogoItem.id === CatalogosIds.Tamanos) {
        createCall = api.createTamaño(values);
      } else if (catalogoItem.id === CatalogosIds.Concentraciones) {
        createCall = api.createConcentracion(values);
      } else if (catalogoItem.id === CatalogosIds.Presentaciones) {
        createCall = api.createPresentacion(values);
      }

      return createCall;
    }

    function updateActivoCall(values) {
      let updateCall = null;
      let activoCall = null;
      if (catalogoItem.id === CatalogosIds.Marcas) {
        updateCall = api.updateMarca;
        activoCall = api.activarMarca;
      } else if (catalogoItem.id === CatalogosIds.Generos) {
        updateCall = api.updateGenero;
        activoCall = api.activarGenero;
      } else if (catalogoItem.id === CatalogosIds.Tamanos) {
        updateCall = api.updateTamaño;
        activoCall = api.activarTamaño;
      } else if (catalogoItem.id === CatalogosIds.Concentraciones) {
        updateCall = api.updateConcentracion;
        activoCall = api.activarConcentracion;
      } else if (catalogoItem.id === CatalogosIds.Presentaciones) {
        updateCall = api.updatePresentacion;
        activoCall = api.activarPresentacion;
      }

      return [updateCall, activoCall];
    }

    function validateInput(values) {
      let errors = {};
      if (catalogoItem.id === CatalogosIds.Marcas) {
        errors = createCatalogoItemFormShortValidate(values);
      } else {
        errors = createCatalogoItemFormValidate(values);
      }
      return errors;
    }

    return (
      <>
        <button
          ref={modalRef}
          type="button"
          className="btn btn-primary"
          data-bs-toggle="modal"
          data-bs-target="#staticBackdropCrearCatalogoItem"
          hidden
        >
          Abrir Crear clientes
        </button>
        <div
          className="modal fade modal-lg"
          id="staticBackdropCrearCatalogoItem"
          data-bs-backdrop="static"
          data-bs-keyboard="false"
          tabIndex="-1"
          aria-labelledby="staticBackdropCrearCatalogoItemLabel"
          aria-hidden="true"
        >
          <div className="modal-dialog">
            <div className="modal-content">
              <div className="modal-header">
                <h5
                  className="modal-title"
                  id="staticBackdropCrearCatalogoItemLabel"
                >
                  {title}
                </h5>
                <button
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                ></button>
              </div>

              <div className="modal-body">
                <form
                  className="row g-3"
                  onSubmit={(event) => {
                    event.preventDefault();
                    return false;
                  }}
                >
                  <div className="">
                    <div className="row">
                      <div className="col">
                        <label
                          htmlFor="validationNombreCorto"
                          className="form-label"
                        >
                          Nombre Corto
                        </label>
                        <input
                          {...formik.getFieldProps("nombreCorto")}
                          {...formikExtra.upperCase("nombreCorto", formik)}
                          type="text"
                          className={`form-control ${invalidClass(
                            formik.errors.nombreCorto,
                          )}`}
                          id="validationNombreCorto"
                          aria-describedby="eeee"
                        />
                        <div className="valid-feedback">Looks good!</div>
                        <div className="invalid-feedback">
                          {formik.errors.nombreCorto}
                        </div>
                      </div>

                      <div className="col align-container-center">
                        <div className="container-center-horizontal">
                          <div className="form-check form-switch container-center-vertical">
                            <input
                              className="form-check-input"
                              type="checkbox"
                              id="flexSwitchCheckDefault"
                              {...formik.getFieldProps("activo")}
                              checked={formik.values.activo}
                              disabled={isActiveDisabled}
                            />
                            <span>
                              <label
                                className="form-check-label"
                                htmlFor="flexSwitchCheckDefault"
                              >
                                Activo
                              </label>
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="">
                    <label htmlFor="validationNombre" className="form-label">
                      Nombre
                    </label>
                    <input
                      {...formik.getFieldProps("nombre")}
                      {...formikExtra.upperCase("nombre", formik)}
                      type="text"
                      className={`form-control ${invalidClass(
                        formik.errors.nombre,
                      )}`}
                      id="validationNombre"
                      aria-describedby="eeee"
                    />
                    <div className="valid-feedback">Looks good!</div>
                    <div className="invalid-feedback">
                      {formik.errors.nombre}
                    </div>
                  </div>
                </form>
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-secondary"
                  data-bs-dismiss="modal"
                  ref={buttonCancelModalRef}
                >
                  Cancelar
                </button>
                <LoadingButton
                  style={{ height: "38px" }}
                  onClick={(e) => {
                    formik.handleSubmit();
                  }}
                  text={"Guardar"}
                  loadingText={"Guardando..."}
                  isLoading={isLoading}
                />
              </div>
            </div>
          </div>
        </div>
      </>
    );
  },
);

export default CreateCatalogoItem;
